export const TEAM_PRODUCTS_URL = "https://api.salespartner.se/api/products";
export const formatTeamNumber = (value) =>
  Number(value).toLocaleString("sv-SE", {
    minimumFractionDigits: Number.isInteger(Number(value)) ? 0 : 2,
    maximumFractionDigits: 2,
  });

export function createTeamCatalog(payload) {
  if (!Array.isArray(payload)) throw new Error("Ogiltigt produktsvar");
  const products = payload
    .filter(
      (p) =>
        p.active === true &&
        Number.isFinite(Number(p.price_sek)) &&
        p.commission_per_unit_sek != null &&
        Number.isFinite(Number(p.commission_per_unit_sek)),
    )
    .map((p) => ({
      id: p.id,
      name: p.name,
      price: Number(p.price_sek),
      commission: Number(p.commission_per_unit_sek),
      category: p.category_slug || "other",
      image:
        [...(p.images || [])].sort(
          (a, b) =>
            Number(!!b.is_primary) - Number(!!a.is_primary) ||
            (a.sort_order || 0) - (b.sort_order || 0),
        )[0]?.url ||
        p.image_url ||
        null,
    }));
  if (!products.length) throw new Error("Inga aktiva produkter");
  const counts = new Map();
  const featured = products
    .filter((p) => p.image)
    .sort(
      (a, b) =>
        b.commission - a.commission || a.name.localeCompare(b.name, "sv"),
    )
    .filter((p) => {
      const count = counts.get(p.category) || 0;
      if (count >= 2) return false;
      counts.set(p.category, count + 1);
      return true;
    })
    .slice(0, 8);
  return {
    categories: [...new Set(products.map(p=>p.category))],
    count: products.length,
    max: Math.max(...products.map((p) => p.commission)),
    featured,
  };
}

export function withCampaign(path, search) {
  const params = new URLSearchParams();
  for (const [key, value] of new URLSearchParams(search))
    if (key.startsWith("utm_")) params.append(key, value);
  return path + (params.size ? `?${params}` : "");
}

export const teamRegistrationUrl = (search = "") => withCampaign("/register-group", search);
export const teamProductUrl = (id, search = "") =>
  withCampaign(`/shop/products/${encodeURIComponent(id)}`, search);

export function createTeamCatalogFromSnapshot(snapshot) {
  const catalog = createTeamCatalog(snapshot.products.map(p => ({...p, active:true, image_url:p.primary_image_url})));
  return {...catalog, count:snapshot.count, max:snapshot.max, categories:snapshot.categories || catalog.categories};
}
